import {
  LocalStorageKey,
  readLocalStorage,
  writeLocalStorage,
} from "@/lib/local-storage";
import { zodBrandedUuid } from "@/utils/helpers";
import type { AnalysisChatV2Id } from "@/utils/types";
import { z } from "zod";

// Keyed by org id.
export type ActiveChatIdsByWorkspace = Partial<
  Record<string, AnalysisChatV2Id>
>;

const activeChatIdsSchema = z.record(
  z.string(),
  zodBrandedUuid<AnalysisChatV2Id>()
);

export const readActiveChatIds = (): ActiveChatIdsByWorkspace =>
  activeChatIdsSchema.safeParse(
    readLocalStorage(LocalStorageKey.UnifiedChatActiveChatIds, {})
  ).data ?? {};

export const writeActiveChatIds = (activeChatIds: ActiveChatIdsByWorkspace) =>
  writeLocalStorage(
    LocalStorageKey.UnifiedChatActiveChatIds,
    Object.fromEntries(
      Object.entries(activeChatIds).flatMap(
        ([orgId, chatId]): [string, string][] =>
          chatId ? [[orgId, chatId]] : []
      )
    )
  );

export const clearActiveChatIds = () =>
  writeLocalStorage(LocalStorageKey.UnifiedChatActiveChatIds, {});
